import { usePermissao } from "@/lib/use-permissao";
import { ExpedienteSection } from "@/components/organization/ExpedienteSection";

// ─── Seção "Expediente" (quando a organização está aberta) ──

export function ExpedienteSecao() {
  const canManage = usePermissao("settings.manage");

  return <ExpedienteSection canManage={canManage} />;
}
